module.exports = __webpack_public_path__ + "img/bg-login-asesi.76e70658.svg";